import axios from "axios";
import {App, blockAccepting, clearChoose, initEvents} from "../store/app";

const URL = document.location.origin.includes("localhost")
	? "https://newdev.paryajpam.com"
	: document.location.origin

export default class HTTP
{
	public static async send(action:string, payload:any=null) {
		return new Promise(async (resolve, reject)=>{
			const send = (payload ? axios.post : axios.get);
			await send(`${URL}/${action}`,payload)
				.then((response)=>{
					response?.data ? resolve(response?.data) : reject("No data");
				}).catch((e)=>{
					reject(e);
				})
		})
	}

	public static async getConfig() {
		return new Promise(async (resolve, reject)=>{
			await HTTP.send('get_prediction_league')
				.then((response)=>{
					if(response) {
						const data = <App>response;
						initEvents(data);
					}
				}).catch((e)=>{
					reject(e);
				})
		})
	}

	public static async confirmPredictions(outcomes:number[]) {
		if(outcomes.length!==4) console.error("Length < 4");
		else {
			return new Promise(async (resolve, reject)=>{
				await HTTP.send('set_prediction_league', {outcomes} )
					.then((response)=>{
						if(response) {
							clearChoose();
							blockAccepting();
							console.log("confirmPredictions", response)
						}
					}).catch((e)=>{
						reject(e);
					})
			})
		}
	}

}
